/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class PartDistributionApi {
    static getInstance() {
        if (!this.instance) this.instance = new PartDistributionApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取各部件分布
    async getPartsDistribution (param,page_num,page_size){
        let url = `/api/sys/parts/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 下载部件分布数据
    async downLoadPartsDistribution (param){
        let url = `/api/sys/parts/download`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 统计部件版本数据
    async partVersionStatistics(param){
        let url = `/api/sys/parts/version/distribution`
        let result = await this.getData(url,param,'GET')
        return result
    }

}

export {
    PartDistributionApi
}